import { calendarResponseSchema } from './calendar';
import { corporateActionSchema } from './corporate-actions';
import { countriesResponseSchema } from './countries';
import {
  economicEventInputSchema,
  economicsResponseInputSchema,
} from './economics-events';
import { keyDevsResponseSchema } from './key-developments-events';
import {
  govTradeResponseSchema,
  insiderTradesResponseSchema,
  iposResponseSchema,
} from './screener-events';

export * from './calendar';
export * from './corporate-actions';
export * from './countries';
export * from './economics-events';
export * from './key-developments-events';
export * from './screener-events';

const financialEventsBasePath = 'financial-events/v1/';
export const financialEvents = {
  getCorporateActionById: {
    path: (id: string) => `${financialEventsBasePath}corporate-actions/${id}`,
    schema: corporateActionSchema,
  },
  postGovTrades: {
    path: `${financialEventsBasePath}gov-trades`,
    schema: govTradeResponseSchema,
  },
  postInsiderTrades: {
    path: `${financialEventsBasePath}insider-trades`,
    schema: insiderTradesResponseSchema,
  },
  postIpos: {
    path: `${financialEventsBasePath}ipos`,
    schema: iposResponseSchema,
  },
  postKeyDevs: {
    path: `${financialEventsBasePath}key-devs`,
    schema: keyDevsResponseSchema,
  },
  getEconomics: {
    path: ({
      from,
      to,
      countries,
      categories,
      page,
      pageSize,
      sortBy,
      sortDesc,
    }: {
      from: string;
      to: string;
      countries?: string[];
      categories?: string[];
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDesc?: boolean;
    }) => {
      const basePath = `${financialEventsBasePath}economics?from=${from}&to=${to}`;
      const countriesParams =
        countries?.map(country => `&country=${country}`) ?? [];
      const categoriesParams =
        categories?.map(category => `&category=${category}`) ?? [];
      const paginationParams =
        page !== undefined && pageSize !== undefined
          ? `&page=${page}&page_size=${pageSize}`
          : '';
      const sortParams = sortBy
        ? `&sort_by=${sortBy}${sortDesc ? '&sort_desc=true' : ''}`
        : '';
      return `${basePath}${countriesParams.join('')}${categoriesParams.join('')}${paginationParams}${sortParams}`;
    },
    schema: economicsResponseInputSchema,
  },
  getEconomicsById: {
    path: (id: string) => `${financialEventsBasePath}economics/${id}`,
    schema: economicEventInputSchema,
  },
  postCalendars: {
    path: `${financialEventsBasePath}calendars`,
    schema: calendarResponseSchema,
  },
  getCountries: {
    path: `${financialEventsBasePath}countries`,
    schema: countriesResponseSchema,
  },
};
